import { jsxs as g, jsx as s } from "react/jsx-runtime";
import { useWindowSize as pe, PrimaryButton as ge, FormInput as Ce, toast as u } from "@systemeio/ui";
import { BadRequest as _e } from "@systemeio/util";
import { useState as n, useRef as we, useEffect as ve } from "react";
import { twMerge as Z } from "tailwind-merge";
import { useTranslation as Ne } from "../../i18n.mjs";
import { FileGrid as Ie } from "./components/file-grid.mjs";
import { FileSearch as Re } from "./components/file-search.mjs";
import { useInfiniteDataFiles as xe } from "./hooks/use-data-files.mjs";
import { useFileActions as ye } from "./hooks/use-file-actions.mjs";
import { useFileDetails as be } from "./hooks/use-file-details.mjs";
import { SortDirectionEnum as Se } from "../../enums/pagination-enums.mjs";
import { useFileUploader as De } from "../file-uploader/hooks/use-file-uploader.mjs";
import { FileDetails as Ee } from "../../components/file-details/index.mjs";
import { ConfirmationModal as L } from "../../components/confirmation-modal/index.mjs";
import { FileUploaderModal as Be } from "../file-uploader/file-uploader-modal.mjs";
import { getImageAspectRatio as Oe, areAspectRatiosEqual as je, getAspectRatioNote as ke } from "../../utils/aspect-ratio.mjs";
import { imageToFile as ze } from "../../utils/image-to-file.mjs";
import { convertFileInfoToDataFile as He } from "../../utils/convert-file-info-to-data-file.mjs";
import { FileDropZone as Ge } from "../../components/file-drop-zone/index.mjs";
import { ImageCropperModal as We } from "../image-cropper/image-cropper-modal.mjs";
import { isImageFile as Ze } from "../../utils/is-image.mjs";
function ct({
  uploadingFromSource: C,
  requiredCropping: F = !0,
  fileUploaderModalProps: o,
  initialSearchFilters: A,
  disabledFileTypeSelect: J,
  disabledFileSourceSelect: K,
  fileSelectorRef: b,
  onSelect: _,
  fileManagerApiType: c
}) {
  var G, W;
  F = !!(F && ((W = (G = o == null ? void 0 : o.imageCropperModalProps) == null ? void 0 : G.imageCropperProps) != null && W.aspectRatio));
  const { t: i } = Ne(), { width: S } = pe(), [w, Q] = n(
    A ?? {
      name: "",
      source: [],
      type: []
    }
  ), [T, V] = n(w), [l, D] = n(), [m, v] = n(), [d, N] = n(), [I, E] = n(""), [a, X] = n(), R = xe({
    filter: T,
    sortColumn: "createdAt",
    sortDirection: Se.Desc,
    fileManagerApiType: c
  }), { resetAndRefetch: B, deleteItemFromData: Y, renameItemFromData: $ } = R, { deleteFile: q, downloadFile: M, renameFile: U } = ye(), { data: t, isFetching: P } = be({
    id: l == null ? void 0 : l.id,
    fileManagerApiType: c
  }), ee = async () => {
    m && (await q(m), Y(m.id), u.success(i("file_manager.file_deleted_successfully")), v(void 0));
  }, te = async (e) => {
    try {
      await M(e);
    } catch {
    }
  }, [oe, x] = n(), ne = async () => {
    var e;
    if (d)
      try {
        x(void 0), await U({ id: d.id, name: I }), $({ id: d.id, name: I }), u.success(i("file_manager.file_renamed_successfully")), N(void 0);
      } catch (r) {
        if (r instanceof _e)
          x((e = r.errors.fields.name) == null ? void 0 : e.join(" "));
        else
          throw r;
      }
  }, h = we(void 0), [ie, y] = n(!1), re = (e) => {
    var r;
    (r = h.current) == null || r.addFilesToWaitingUpload(e), y(!0);
  };
  ve(() => {
    o != null && o.uploaderRef && (o.uploaderRef.current = h.current);
  }, [h.current]), b && (b.current = {
    setFileUploadModalOpen: y
  });
  const { createFileUploader: se } = De(c), [ae, O] = n(!1), [ce, j] = n(!1), [me, k] = n(!1), [le, z] = n(), fe = (e) => {
    O(!0), z(e);
  }, H = () => {
    O(!1), z(void 0);
  }, ue = async (e) => {
    try {
      j(!0);
      const f = await se(() => {
      }).upload({
        file: e,
        source: C
      });
      if (!f) throw new Error();
      const p = He(f, C);
      _(p), B(), H();
    } catch {
      u.error(i("file_manager.error"));
    } finally {
      j(!1);
    }
  }, Fe = async () => {
    var r, f;
    if (!a) return;
    const e = (f = (r = o == null ? void 0 : o.imageCropperModalProps) == null ? void 0 : r.imageCropperProps) == null ? void 0 : f.aspectRatio;
    if (!F || !Ze(a) || !e || isNaN(e)) {
      _(a);
      return;
    }
    try {
      k(!0);
      const [p, de] = await Oe(a.path);
      if (je(de, e)) {
        _(a);
        return;
      }
      u(ke(e));
      const he = await ze(p, a.name, a.type);
      fe(he);
    } catch {
      u.error(i("file_manager.error"));
    } finally {
      k(!1);
    }
  };
  return /* @__PURE__ */ g("div", { className: "flex gap-5", children: [
    /* @__PURE__ */ s(
      "div",
      {
        className: Z(
          l ? "w-1/2" : "w-full",
          S < 1024 && l ? "hidden" : "auto"
        ),
        children: /* @__PURE__ */ g("div", { className: "flex flex-col gap-5", children: [
          /* @__PURE__ */ s(
            Re,
            {
              isFetching: R.isFetching,
              values: w,
              disabledFileSourceSelect: K,
              disabledFileTypeSelect: J,
              onChange: Q,
              onSubmit: () => {
                V(w);
              }
            }
          ),
          /* @__PURE__ */ s(
            Ie,
            {
              dataFilesApi: R,
              onDetails: D,
              onSelect: X,
              specialElementInGrid: /* @__PURE__ */ s(
                Ge,
                {
                  className: "h-full w-full",
                  dropZoneClassName: "w-full h-full items-center",
                  labelClassName: "text-text-primary",
                  onSelect: re,
                  multiple: !0
                }
              ),
              ...!(c != null && c.isCommon) && {
                onDelete: v,
                onDownload: te,
                onRename: (e) => {
                  N(e), E(e.name);
                }
              }
            }
          ),
          /* @__PURE__ */ g("div", { className: "sticky bottom-4 flex items-center justify-between sm:relative sm:bottom-0", children: [
            /* @__PURE__ */ g("div", { className: "text-text-tertiary text-sm", children: [
              +!!a,
              " ",
              i("file_manager.file_selector.files_selected")
            ] }),
            /* @__PURE__ */ s(
              ge,
              {
                className: "min-w-14",
                disabled: a === void 0,
                isFetching: me,
                onClick: () => Fe(),
                children: i("file_manager.select")
              }
            )
          ] })
        ] })
      }
    ),
    l && /* @__PURE__ */ s(
      Ee,
      {
        className: Z(S < 1024 ? "w-full" : "max-w-[calc(50%-20px)]"),
        fileType: t == null ? void 0 : t.type,
        src: (t == null ? void 0 : t.path) ?? (t == null ? void 0 : t.thumbnail) ?? void 0,
        alt: t == null ? void 0 : t.name,
        name: t == null ? void 0 : t.name,
        size: t == null ? void 0 : t.size,
        onClose: () => D(void 0),
        isFetching: P
      }
    ),
    /* @__PURE__ */ s(
      L,
      {
        opened: !!m,
        onClose: () => v(void 0),
        confirmationText: i("file_manager.file_selector.file_deletion_confirmation_text", {
          file: m == null ? void 0 : m.name
        }),
        onConfirm: () => ee()
      }
    ),
    /* @__PURE__ */ s(
      L,
      {
        opened: !!d,
        onClose: () => {
          N(void 0), x(void 0);
        },
        title: i("file_manager.file_selector.rename_file"),
        confirmButtonCaption: i("file_manager.rename"),
        confirmationContent: /* @__PURE__ */ s(
          Ce,
          {
            label: i("file_manager.file_selector.file_name"),
            placeholder: i("file_manager.file_selector.enter_new_file_name"),
            value: I,
            onChange: (e) => E(e.target.value),
            error: oe
          }
        ),
        onConfirm: () => ne()
      }
    ),
    /* @__PURE__ */ s(
      Be,
      {
        ...o,
        uploaderRef: h,
        opened: ie,
        source: C,
        showCroppingNote: F,
        onClose: () => y(!1),
        onDone: () => B(),
        fileManagerApiType: c
      }
    ),
    /* @__PURE__ */ s(
      We,
      {
        isFetching: ce,
        imageFile: le,
        opened: ae,
        onClose: H,
        onCrop: ue,
        actionButtonLabel: i("file_manager.file_upload.crop_and_select_file"),
        ...o == null ? void 0 : o.imageCropperModalProps
      }
    )
  ] });
}
export {
  ct as FileSelector
};
